import { createApi } from '@reduxjs/toolkit/query/react';

import QueryString from 'qs';

import { schema } from '@/helpers/utils/qs';
import { ResponseError } from '@/types/Error';
import { ProductIngredientsResponse } from '@/types/ProductsIngredients';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

const contentTypes = {
  applicationJson: 'application/json',
};

export const productIngredientsApi = createApi({
  reducerPath: 'productIngredientsApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({
    basePath: '',
    useStrapiServer: true,
    cache: 'no-store',
  }),
  tagTypes: ['productIngredients'],
  endpoints: builder => ({
    getProductsIngrediens: builder.query<SuccessResponse<ProductIngredientsResponse>, void>({
      query: () => ({
        url: `/api/categories?${QueryString.stringify(schema, {
          encodeValuesOnly: true, // prettify URL
        })}`,
        headers: {
          'Content-Type': contentTypes.applicationJson,
        },
      }),
      transformResponse: (response: SuccessResponse<ProductIngredientsResponse>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
  }),
});

export const { useGetProductsIngrediensQuery } = productIngredientsApi;
